export default __webpack_public_path__ + "static/media/get-all-the-meme.1cd2477d.jpg";